import React from "react";

const UploadRfpIcon = ({
  color = "var(--heading-color)",
  size = "20",
  fillColor,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 78 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.9998 24.7497V66.3747M38.9998 24.7497L52.8748 38.6247M38.9998 24.7497L25.1248 38.6247M64.4373 47.8747C71.4627 47.8747 75.9998 42.1813 75.9998 35.1559C75.9996 32.3745 75.0876 29.6699 73.4036 27.4562C71.7195 25.2426 69.3563 23.642 66.6758 22.8997C66.2634 17.7125 64.1136 12.8161 60.574 9.00196C57.0344 5.18784 52.3118 2.67898 47.1699 1.881C42.0279 1.08302 36.7671 2.04256 32.238 4.60449C27.7089 7.16642 24.1762 11.181 22.211 15.9992C18.0736 14.8523 13.6501 15.3959 9.91351 17.5105C6.17695 19.6251 3.43344 23.1375 2.28655 27.2749C1.13965 31.4123 1.68331 35.8359 3.79792 39.5724C5.91254 43.309 9.42489 46.0525 13.5623 47.1994"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadRfpIcon;
